class ApiAdapter {
  async fetch ({ action, params } = {}) {
    return { response: await this.requests()[action](params) }
  }
}

export default ApiAdapter
